// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1hu8w","description":"PatientConsentPreview_description__309N0"};